var dd = require('react-dd');
var _ = require('lodash');
var esUtils = require('../../../utils/esUtils');
var FormInputMixin = require('../FormInputMixin');

var ranges = [
	[0, 0],
	[0, 1000],
	[1000, 2500],
	[2500, 5000],
	[5000, 7500],
	[7500, 10000],
	[10000, 15000],
	[15000, 20000],
	[20000, Infinity]
];
var ranges_options = _.map(ranges, function(range){
	if(_.isArray(range)){
		range = esUtils.format_budget_range(range);
	}
	return range;
});

var placeholder_value = '__some$random$uuid__';
var getSelectedOption = function(value){
	if(_.isArray(value)){
		var i;
		for(i = 0; i < ranges.length; i++){
			if(_.isEqual(ranges[i], value)){
				return i;
			}
		}
	}
	return placeholder_value;
};


module.exports = {
	component: dd.createClass({
		mixins: [FormInputMixin],
		__onChange: function(e){
			var new_value = ranges[e.target.value];
			this._input_newValue(_.isArray(new_value) ? new_value : null);
		},
		render: function(){
			var field = this.props.field;
			var value = getSelectedOption(this.props.value);

			if(field.read_only){
				return dd.p({className: 'form-control-static'},
					_.has(ranges_options, value) ? ranges_options[value] : null
				);
			}

			return dd.select({
					className: 'form-control' + (field.disabled ? ' disabled' : ''),
					value: value,
					name: this.props.field_path,
					onChange: this.__onChange,
					disabled: field.disabled ? 'disabled' : null
				},
				dd.option({value: placeholder_value}, field.placeholder || '-- select price range --'),
				_.map(ranges_options, function(text, i){
					return dd.option({key: i, value: i}, text);
				})
			);
		}
	}),
	validate: function(value){
		return _.isArray(value) || 'Please select a price range';
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/inputs/esBudgetRange.js
// module id = 204
// module chunks = 0 1 2 3 4